import { atom } from "jotai";

export const isAiProgressPopupOpenAtom = atom(false);
